import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App.tsx'
import { DriverApp } from './DriverApp.tsx'
import './index.css'
import './styles/cashalot.css'

const STALE_BUNDLE_KEY = 'edo_stale_bundle_reload'
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault?.()
  if (sessionStorage.getItem(STALE_BUNDLE_KEY)) return
  sessionStorage.setItem(STALE_BUNDLE_KEY, '1')
  window.location.reload()
})
window.addEventListener('load', () => {
  sessionStorage.removeItem(STALE_BUNDLE_KEY)
})

const isDriverCabinet =
  window.location.pathname === '/driver' ||
  window.location.pathname.startsWith('/driver/')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isDriverCabinet ? <DriverApp /> : <App />}
  </React.StrictMode>,
)
